<!-- TODO: Search hidden for now, delete if not necessary later -->
<!-- @if (!loading()) {
  <mat-form-field class="custom-form w-full mb-5">
    <app-icon src="/icons/search.svg" matPrefix alt="Search" class="w-4 h-4" />
    <input matInput [formControl]="searchControl" [placeholder]="'shared.search' | translate" />
  </mat-form-field>
} @else {
  <div class="flex w-full mb-5">
    <ngx-skeleton-loader class="w-full h-12" [theme]="{ height: '48px', width: '100%', 'border-radius': '100vw' }" />
  </div>
} -->

<div class="max-h-[calc(100vh-468px)] overflow-y-auto -mx-4 px-4">
  <div class="grid grid-cols-[repeat(auto-fill,260px)] gap-5 justify-between">
    @if (!loading()) {
      @for (creator of filteredCreators(); track creator.id) {
        @let canViewCreator = !creatorBriefingMode() && !exportMode();
        <div class="flex w-[260px] relative rounded-2xl bg-shikenso-gray-base">
          @if (!exportMode() && creatorCampaignExports().get(creator.id)?.isActive) {
            <div
              class="absolute top-4 left-3 flex items-center justify-center px-2 py-1 rounded-full bg-shikenso-info-light"
            >
              <span class="text-[10px] font-bold text-shikenso-info-base">
                {{ 'shared.statuses.briefed' | translate }}
              </span>
            </div>
          }

          @if (!creatorBriefingMode() && !exportMode()) {
            <div class="absolute top-4 right-4" (click)="$event.stopPropagation()">
              <app-creator-actions-menu
                [creator]="creator"
                [campaign]="campaign()"
                [creatorCampaignExports]="creatorCampaignExports()"
                [viewMode]="viewMode"
                [currentTab]="currentTab"
              />
            </div>
          }

          <div class="flex flex-col items-center w-full h-full">
            <div class="flex flex-col gap-2 pt-4 px-3 w-full items-center justify-center">
              <div
                class="flex flex-col items-center rounded p-2 transition-colors w-fit max-w-full"
                matTooltipPosition="above"
                [class.cursor-pointer]="canViewCreator"
                [class.hover:bg-shikenso-pink-base-12]="canViewCreator"
                [matTooltip]="canViewCreator ? ('pages.campaignDetails.table.viewCreator' | translate) : ''"
                [matTooltipShowDelay]="500"
                (click)="canViewCreator && onViewCreator(creator, $event)"
              >
                <div class="relative">
                  <app-icon-badge
                    [content]="creator.icon"
                    [fallbackText]="creator.name"
                    [size]="80"
                    [iconSize]="80"
                    [fontSize]="36"
                    [borderRadius]="100"
                  />
                  @if (!exportMode() && invitedCreatorIds().has(creator.id)) {
                    <div
                      class="absolute bottom-0 right-0 flex items-center justify-center rounded-full bg-shikenso-info-light p-1 border border-white"
                    >
                      <app-icon src="/icons/shield-check.svg" alt="accepted" color="shikenso-info-base" [size]="12" />
                    </div>
                  }
                </div>

                <span class="text-base font-bold text-center">{{ creator.name }}</span>
              </div>
            </div>

            <hr class="w-full border-shikenso-purple-base-12 -mx-3 my-3" />

            <div class="flex flex-col gap-3 px-3 pb-3 w-full items-center justify-center">
              @if (campaign()?.budget && campaign()?.currency) {
                <div
                  class="flex items-center justify-between px-4 py-2 w-full bg-shikenso-base-white border border-shikenso-purple-base-12 rounded-full"
                >
                  <div class="flex items-center gap-2">
                    <app-icon src="icons/cash.svg" alt="cost" class="w-4 h-4" />
                    <span class="text-xs">
                      {{ 'pages.campaignForm.sections.creatorsAndCtas.creatorAndBudget.budget' | translate }}
                    </span>
                  </div>

                  <span class="text-base font-bold -mb-0.5">
                    {{ campaignCreatorsMap().get(creator.id)?.cost ?? 0 | numberSuffix: true }}
                    {{ campaign()?.currency }}
                  </span>
                </div>
              }

              <div class="flex items-center gap-2 mt-2">
                @for (usedPlatform of creator.usedPlatforms; track getUsedPlatformTracking(usedPlatform)) {
                  <a
                    class="hover:scale-110 transition-all duration-75"
                    target="_blank"
                    [href]="generateSocialUrl(usedPlatform)"
                    (click)="$event.stopPropagation()"
                  >
                    <app-social-badge
                      backgroundColor="transparent"
                      [type]="usedPlatform.platform"
                      [size]="16"
                      [iconSize]="16"
                    />
                  </a>
                }
              </div>
            </div>

            <hr class="w-full border-shikenso-purple-base-12 -mx-3 mt-2 mb-3" />

            <div class="flex flex-col gap-1 px-3 pb-3 w-full">
              <div class="flex items-center gap-1 mb-1">
                <span class="w-3 h-3 rounded-full shrink-0" [class]="getStatusDotClass(creator.mergedStatus)"></span>
                <span class="text-sm font-medium">{{ getStatusLabel(creator.mergedStatus) | translate }}</span>
              </div>

              @switch (creator.mergedStatus) {
                @case (EAnalyticsStatus.ok) {
                  <button
                    type="button"
                    class="flex w-fit items-center gap-1.5 cursor-pointer rounded px-1 py-1 hover:bg-shikenso-pink-base-12 transition-all text-left"
                    (click)="onAllGoodRowClick(creator, $event)"
                  >
                    <span class="w-1.5 h-1.5 rounded-full shrink-0 bg-shikenso-success-base"></span>
                    <span class="text-xs">{{ creator.ctaKpiStatus.currentOkContents }}</span>
                    <span class="text-xs">{{ 'pages.campaignDetails.creators.popup.matchedContent' | translate }}</span>
                  </button>
                }
                @case (EAnalyticsStatus.processing) {
                  @if (creator.ctaKpiStatus.currentMissingContents > 0) {
                    <button
                      type="button"
                      class="flex w-fit items-center gap-1.5 cursor-pointer rounded px-1 py-1 hover:bg-shikenso-pink-base-12 transition-all text-left"
                      (click)="onMissingContentsRowClick(creator, $event)"
                    >
                      <span class="w-1.5 h-1.5 rounded-full shrink-0 bg-shikenso-error-bright"></span>
                      <span class="text-xs">
                        {{
                          'pages.campaignDetails.overview.missingContents'
                            | translate: { count: creator.ctaKpiStatus.currentMissingContents }
                        }}
                      </span>
                    </button>
                  }

                  @if (creator.ctaKpiStatus.expectedContents - creator.ctaKpiStatus.currentMissingContents > 0) {
                    <button
                      type="button"
                      class="flex w-fit items-center gap-1.5 cursor-pointer rounded px-1 py-1 hover:bg-shikenso-pink-base-12 transition-all text-left"
                      (click)="onNotStartedRowClick(creator, $event)"
                    >
                      <span class="w-1.5 h-1.5 rounded-full shrink-0 bg-shikenso-purple-base-60"></span>
                      <span class="text-xs">
                        {{ creator.ctaKpiStatus.expectedContents - creator.ctaKpiStatus.currentMissingContents }}
                      </span>
                      <span class="text-xs">
                        {{ 'pages.campaignDetails.creators.popup.plannedContent' | translate }}
                      </span>
                    </button>
                  }
                }
                @default {
                  @for (row of getPopoverRows(creator); track row.label) {
                    <button
                      type="button"
                      class="flex w-fit items-center gap-1.5 cursor-pointer rounded px-1 py-1 hover:bg-shikenso-pink-base-12 transition-all text-left"
                      (click)="onPopoverRowClick(row, $event)"
                    >
                      <span class="w-1.5 h-1.5 rounded-full shrink-0" [class]="row.colorClass"></span>
                      <span class="text-xs">{{ row.label | translate: { count: row.count } }}</span>
                    </button>
                  }
                }
              }
            </div>
          </div>
        </div>
      }
    } @else {
      @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track i) {
        <ngx-skeleton-loader class="h-[311px]" [theme]="{ height: '311px', width: '260px', 'border-radius': '16px' }" />
      }
    }
  </div>
</div>
